<div class="ltms-description">{{ mainDiscription }}</div>
<div class="cardHolder">
    <div class="card ratingCard">
        <div class="cardHeading">Project NPS</div>
        <div class="cardData">50</div>
        <div class="cardInfo">Overall score</div>
    </div>
    <div class="card responseCard">
        <div class="cardHeading">Response Count</div>
        <div class="cardData">1,380</div>
        <div class="cardInfo">Total responses</div>
    </div>
    <div class="card topCard">
        <div class="cardHeading">Promoters</div>
        <div class="cardData">821</div>
        <div class="cardInfo">59% of responses</div>
    </div>
    <div class="card midCard">
        <div class="cardHeading">Passives</div>
        <div class="cardData">341</div>
        <div class="cardInfo">25% of responses</div>
    </div>
    <div class="card bottomCard">
        <div class="cardHeading">Detractors</div>
        <div class="cardData">127</div>
        <div class="cardInfo">9% of responses</div>
    </div>
</div>
<div class="chartHolder">
    <div class="chartCard lineChart">
        <div class="filter">
            <div>
                <div class="card-name">{{ 'NPS' }} Trend • {{ 'Maturity Claim hierarchy' }}</div>
                <div class="ltms-description">{{ scoreTrendsDiscription }}</div>
            </div>
            <span class="other-filters">
                <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('lineChart')" (onFullscreenClick)="onFullScreen($event, 'lineChart')" (onDownloadClick)="onDownload('lineChart')" (onTrendClick)="onTrendChange($event, 'lineChart')"></app-score-widget>
            </span>
        </div>
        <div class="chart">
            <app-score-line-chart [chartPlugins]="lineChartPlugins" [chartData]="lineChartData" (onGraphDataPointClick)="onGraphDataPointClick($event, 'lineChart', '')"></app-score-line-chart>
        </div>
    </div>
    <div class="chartCard barChart">
        <div class="filter">
            <div>
                <div class="card-name">{{ 'Response' }} Trend • {{ 'Maturity Claim hierarchy' }}</div>
                <div class="ltms-description">{{ scoreTrendsDiscription }}</div>
            </div>
            <span class="other-filters">
                <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('lineChart')" (onFullscreenClick)="onFullScreen($event, 'lineChart')" (onDownloadClick)="onDownload('lineChart')" (onTrendClick)="onTrendChange($event, 'lineChart')"></app-score-widget>
            </span>
        </div>
    </div>
</div>

<div class="tableCard">
    <div class="filter">
        <div>
            <div class="card-name">Score</div>
            <div class="ltms-description">{{ scoreDiscription }}</div>
        </div>
        <!-- <span class="other-filters">
            <span class="viewByText">View by</span>
            <app-score-dropdown-menu [ngbTooltip]="viewTypeDropdown.config.isDisabled ? 'No cohorts configured.' : null" [config]="viewTypeDropdown.config" [selectedOption]="viewTypeDropdown['selectedOption']" [options]="viewTypeDropdown.options" (selectedOptionChange)="onOptionChange($event, 'viewType')"></app-score-dropdown-menu>
            <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('drilldown')" (onFullscreenClick)="onFullScreen($event, 'drillDownTable')" (onDownloadClick)="onDownload('drillDownTable')"></app-score-widget>
        </span> -->
    </div>
    <app-score-drilldown-table-new></app-score-drilldown-table-new>
</div>